import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z"
}), 'FormatTextdirectionLToR');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatTextdirectionLToR.js
// module id = 3899
// module chunks = 2